import type { ApiObject } from '@rudderstack/analytics-js';
import { RudderAnalytics } from '@rudderstack/analytics-js';
import { StatsigClient } from '@statsig/react-bindings';
import { GAEventName } from './ga-event-name.enum';
import { DataLayerEvent } from './types';

export const RUDDERSTACK_ALLOWED_EVENTS: ReadonlySet<GAEventName> = new Set([
  GAEventName.ADD_TO_CART,
  GAEventName.ADD_PAYMENT_INFO,
  GAEventName.BEGIN_CHECKOUT,
  GAEventName.PRODUCT_SELECTION,
  GAEventName.PURCHASE,
  GAEventName.ADD_SHIPPING_INFO,
  GAEventName.SUBSCRIPTION_SELECTION,
  GAEventName.SUB_AND_SAVE_TOGGLE,
  GAEventName.REVIEW_ORDER,
  GAEventName.PURCHASE_INTENT_CTA,
  GAEventName.NEWSLETTER_SIGNUP_SUCCESS,
  GAEventName.HISTORY_CHANGE,
  GAEventName.LOGIN,
  GAEventName.BANNER_CLICK,
  GAEventName.SWAP_TO_TRAVELPACK,
  GAEventName.SWAP_TO_POUCH,
  GAEventName.NEXT_ORDER_ONLY,
  GAEventName.PRODUCT_CARD_CLICK,
  GAEventName.POPUP_VIEWED,
  GAEventName.EMAIL_SUBMISSION,
  GAEventName.PHONE_SUBMISSION,
  GAEventName.QUIZ_STARTED,
  GAEventName.QUIZ_COMPLETED
]);

export const logRudderstackEvent = (dataLayerEvent: DataLayerEvent) => {
  const rudderAnalytics = RudderAnalytics.globalSingleton;
  const eventName = dataLayerEvent.event || dataLayerEvent.event_name;

  if (!rudderAnalytics || !eventName) {
    return;
  }

  // Get Statsig stable ID from the client instance
  const stableId = StatsigClient.instance().getContext().stableID;

  if (RUDDERSTACK_ALLOWED_EVENTS.has(eventName as GAEventName)) {
    try {
      // Add Statsig data to the event
      const eventData = {
        ...dataLayerEvent,
        statsigStableID: stableId
      };

      if (eventName === GAEventName.HISTORY_CHANGE) {
        rudderAnalytics.page(eventData as ApiObject);
      } else {
        rudderAnalytics.track(eventName, eventData as ApiObject);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error sending Rudderstack event:', error);
    }
  }
};
